// extracted by mini-css-extract-plugin
module.exports = {"high-risk":"high-risk_high-risk__Amp2l","high-risk_size_xs":"high-risk_high-risk_size_xs__2tyWa","high-risk_size_s":"high-risk_high-risk_size_s__3r2N5"};